import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class RegularExpressionsConstants {
    public NAME = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/;
    public EMAIL = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    public PASSWORD = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,}$/;
    public PHONE = /^\d{10}$/;
    public DNI = /^\d{8}$/;
    public USERNAME = /^[a-zA-Z0-9_+-]*$/;
    public PASSPORT_NUMBER = /\d{8}[a-zA-Z]{1}/;
    public URL = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
}
